export default __webpack_public_path__ + "static/media/Line2.1a25f559.svg";